import useMutationCall from "../../../hooks/useMutationCall";
import { useVerifyActivityMutation } from "../timelogsSlice";

const useVerifyActivity = () => {
  return useMutationCall(useVerifyActivityMutation);
};

export default useVerifyActivity;
